jQuery(($) => {
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Browser - Keydown Focus Class
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('body').on('keydown', function () {
    if (!$('.keyboard-in-use')[0]) {
      $(this).addClass('keyboard-in-use');
    }
  }); 

  $('body').on('mousedown', function () {
    if ($('.keyboard-in-use')[0]) {
      $(this).removeClass('keyboard-in-use');
    }
  });


  $(window).on('load resize', function () {
    if (($('body').css('overflow', 'hidden') && !$('.o-header--open')[0]) || $(window).width() >= 1200) {
      $('body').removeAttr('style');
    }
  }); 


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // _Header
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
  // ∟StickyNav
  //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
 
  $(window).on('load resize scroll', function () {
    var scrollTop = $(window).scrollTop();
    var headerTop = $('.o-header').offset().top;
 
    if (scrollTop > headerTop) {
      $('.o-header').addClass('o-header--sticky');
      $('body').addClass('scrolling');
    } else {
      $('.o-header').removeClass('o-header--sticky');
      $('body').removeClass('scrolling');
    }
  });

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡ 
  // ✅ Organism: Lesson Header - Sticky
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ($('.o-lesson-header__nav-bar')[0]) {

    $(window).on('scroll', function () {
      const scroll    = $(this).scrollTop();
      const $header   = $('.o-lesson-header');
      const stickyPos = $('.o-lesson-header__top').height();
      const $skipper  = $('.u-skip-to-content');

      if (scroll >= stickyPos) {
        if (!$('.o-lesson-header--stick')[0]) {
          $header.addClass('o-lesson-header--stick');
          $skipper.addClass('u-skip-to-content--hide');

          if ($('.o-notification-bar')[0] && !$('.o-lesson-header--sticky-notification-bar')[0]) {
            $header.addClass('o-lesson-header--sticky-notification-bar');
          }
        }
      } else {
        if ($('.o-lesson-header--stick')[0]) {
          $header.removeClass('o-lesson-header--stick');
          $skipper.removeClass('u-skip-to-content--hide');

          if ($('.o-notification-bar')[0]) {
            $header.removeClass('o-lesson-header--sticky-notification-bar');
          }
        }
      }
    });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ MarkChapterasComplete
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  if ($('.js-mark-as-complete')[0]) {z
    $('.js-mark-as-complete').on('mark_as_complete', function (event, post_id, user_id) {
      var el = $(this);

      $.post(AJAX.url, {
        action: 'mark_as_complete',
        post_id: post_id,
        user_id: user_id,
      }, function (result) {
        if (result.success) {
          $('.o-nav-bar__item--active').find('.o-nav-bar__icon').addClass('o-nav-bar__icon--visible');

          el.css('display', 'none');
        }
      });
    });

    $('.js-mark-as-complete').click(function () {
      var post_id = $(this).attr('data-post-id'),
          user_id = $(this).attr('data-id');

      if (!post_id || !user_id) return;

      $(this).trigger('mark_as_complete', [post_id, user_id]);
    });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Unit Anchor
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $(window).load(function () {
    if ($('.o-featured-units')[0] && $('.m-accordion--open')[0]) {
      var hash   = '#lessons',
          target = $('[id=' + hash.slice(1) + ']');

      $('html, body').animate({
        scrollTop: target.offset().top - 90
      }, 300, function () {
        const $target = $(target);

        $target.focus();

        if ($target.is(":focus")) {
          return false;
        } else {
          $target.focus();
        };
      });
    }
  });


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Modal
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  function closeModal(el, trigger) {
    const $modal = $(el).closest(".m-modal");
    const triggerId = $modal.data("controlledby");
    const $tabButton = $modal.find('.m-nav-tab-list__item ');
    const $tabPanel = $modal.find('.js-panel');

    if ($tabButton) {
      $tabButton.removeClass('.m-nav-tab-list__item--selected');
    }

    if ($('.m-courses-navigation-block').hasClass('right-panel-opened')) {
      $('.m-courses-navigation-block').removeClass('right-panel-opened');

      if ($('.m-lesson-links-panels__lesson-links-panel').hasClass('opened')) {
        $('.m-lesson-links-panels__lesson-links-panel').removeClass('opened');
      }
    }

    if ($('.m-courses-navigation-block').hasClass('middle-panel-opened')) {
      $('.m-courses-navigation-block').removeClass('middle-panel-opened');
    }

    if ($tabPanel) {
      $tabPanel.removeClass('opened');
    }

    if ($modal.hasClass('m-modal--required')) return;

    $modal
      .removeClass("m-modal--open")
      .attr("tabindex", "-1");

    if (triggerId) {
      $(`#${triggerId}`)
        .removeClass('m-modal-trigger__trigger--active')
        .focus();
    }

    $modal.trigger('close', [trigger]);
  }

  function openModal(id, focusOnModal, trigger, focusFirstPanel) {
    const $modal = $(`#${id}`);
    const $panel = $modal.find('.js-panel:first');

    $modal
      .addClass("m-modal--open")
      .attr("tabindex", "1");

    if (focusOnModal) {
      setTimeout(function () {
        $modal.focus();
      }, 100);
    } else {
      const $focusable = $modal.find(
        'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const $firstFocusable = $focusable[0];

      setTimeout(function () {
        $firstFocusable.focus();
      }, 100);
    }

    $modal.trigger('open', [trigger]);

    if (focusFirstPanel) {
      $panel.addClass('opened');

      $('.m-courses-navigation-block').addClass('middle-panel-opened');
    }
  }

  function toggleModal(el, id, focusOnModal) {
    const $modal = $(`#${id}`);

    if ($modal.hasClass('m-modal--open')) {
      closeModal($modal.find('*:first'), el);
    } else {
      openModal(id, focusOnModal, el);
    }
  }

  if ($(".m-modal")[0]) {
    $(".m-modal__close, .m-modal__overlay").click(function () {
      closeModal(this);
    });

    // $('.m-modal button, [href], .m-modal input:not([type="hidden"]), .m-modal select, .m-modal textarea, .m-modal [tabindex]:not([tabindex="-1"]), .m-modal').blur(function(e) {
    //   if ( e.relatedTarget === null
    //     || (
    //       !$(e.relatedTarget).closest('.m-modal')[0]
    //       && !$(e.relatedTarget).is('.m-modal')
    //       && !$(e.relatedTarget).is('.m-modal-trigger__trigger')
    //     )
    //   ) {
    //     closeModal(this);
    //   }
    // });

    $(".m-modal").keydown(function (e) {
      if (e.key === "Tab") {
        const $focusable = $(this).find(
          'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        const $firstFocusable = $focusable[0];
        const $lastFocusable = $focusable[$focusable.length - 1];

        if (
          $(e.target).is($lastFocusable) && !e.shiftKey ||
          ($(e.target).is($firstFocusable) && e.shiftKey)
        ) {
          e.preventDefault();

          if ($(e.target).is($lastFocusable)) {
            $firstFocusable.focus();
          } else {
            $lastFocusable.focus();
          }
        } else if ($(e.target).is(".m-modal")) {
          e.preventDefault();

          $firstFocusable.focus();
        }
      } else if (e.key === "Escape" || e.key === "Esc") {
        if (!$(e.target).is('.a-select *')) {
          closeModal(this);
        }
      }
    });

    $('.m-modal').on('open', function () {
      const $modal = $(this);
      const $media = $modal.find('video, audio');

      if ($media[0] && !$media.hasClass('no-autoplay')) {
        $media.trigger('playMedia');
      }
    });

    $('.m-modal').on('close', function () {
      const $modal = $(this);
      const $media = $modal.find('video, audio');

      if ($media[0]) $media.trigger('stopMedia');
    });

    $('.m-modal').on('open', function (e, trigger) {
      const $modal = $(this);
      const $form = $modal.find('.m-gravity-form');
      const $field = $form.find('.gform_fields .js-redirect-url');
      const $input = $field.find('.ginput_container input');

      let redirectURL = $(trigger).data('url');

      if ($input[0] && redirectURL) $input.attr('value', redirectURL);
    });

    $('.m-modal').on('close', function () {
      const $modal = $(this);
      const $form = $modal.find('.m-gravity-form');
      const $field = $form.find('.gform_fields .js-redirect-url');
      const $input = $field.find('.ginput_container input');

      if ($input[0]) $input.attr('value', '');
    }); 

    $('.m-video-player__video, .m-audio-player__audio').on('playMedia', function (e) {
      console.log(e);
      console.log(target);
      e.target.plyr.play();
    });

    $('.m-video-player__video, .m-audio-player__audio').on('stopMedia', function (e) {
      e.target.plyr.stop();
      e.target.plyr.restart();
    });
  }

  if ($(".m-modal-trigger__trigger")[0]) {
    $(".m-modal-trigger__trigger").mousedown(function () {
      const modalId = $(this).attr("aria-controls");

      $(this).toggleClass('m-modal-trigger__trigger--active');
      toggleModal(this, modalId, true);
    });

    $(".m-modal-trigger__trigger").keydown(function (e) {
      if (e.key === 'Enter' || e.key === 'spacebar' || e.key === ' ') {
        e.preventDefault();

        const modalId = $(this).attr("aria-controls");

        $(this).addClass('m-modal-trigger__trigger--active');
        openModal(modalId, false, this, true);
      }
    });
  }
});